export const ActionTypes = {
  GET_OTP_REQUEST: "GET_OTP_REQUEST",
  GET_OTP_SUCCESS: "GET_OTP_SUCCESS",
  GET_OTP_ERROR: "GET_OTP_ERROR",
  CHECK_OTP_CODE_REQUEST: "CECK_OTP_CODE_REQUEST",
  CHECK_OTP_CODE_SUCCESS: "CHECK_OTP_CODE_SUCCESS",
  CHEKC_OTP_CODE_ERROR: "CHEKC_OTP_CHECK_ERROR",
  SEND_FILES_REQUEST: "SEND_FILES_REQUEST",
  SEND_FILES_SUCCESS: "SEND_FILES_SUCCESS",
  SEND_FILES_ERROR: "SEND_FILES_ERROR",
  SELECT_USER: "SELECT_USER",
  CHANGE_PASSPORT_TYPE: "CHANGE_PASSPORT_TYPE",
  CHANGE_NUMBER_FIELD: "CHANGE_NUMBER_FIELD",
  CHANGE_OTP_CODE_FIELD: "CHANGE_OTP_CODE_FIELD",
  CHANGE_NUMBER: "CHANGE_NUMBER",
  RESET_ERROR: "RESET_ERROR",
  RESTART_DATA: "RESTART_DATA",
  CREATE_APPLICATION_REQUEST: "CREATE_APPLICATION_REQUEST",
  CREATE_APPLICATION_SUCCESS: "CREATE_APPLICATION_SUCCESS",
  CREATE_APPLICATION_FAILURE: "CREATE_APPLICATION_FAILURE",
  SELECT_USER_FOR_CREATE_APP: "SELECT_USER_FOR_CREATE_APP",
  UPDATE_CLIENT_ID: "UPDATE_CLIENT_ID",
  SET_TITLE: "SET_TITLE",
  SET_SUB_TITLE:"SET_SUB_TITLE",
  SET_API_KEY_FROM_KM: "SET_API_KEY_FROM_KM",
  CHECK_TOKEN_REQUEST: "CHECK_TOKEN_REQUEST",
  CHECK_TOKEN_SUCCESS: "CHECK_TOKEN_SUCCESS",
  CHECK_TOKEN_FAILURE: "CHECK_TOKEN_FAILURE",
  STOP_LOADING: "STOP_LOADING",
  SWITCH_LANG: "SWITCH_LANG",
  REDIRECT: "REDIRECT",
  THROW_ERROR_MESSAGE: "THROW_ERROR_MESSAGE",
  CLEAR_ERROR: "CLEAR_ERROR",

};
